import { type AuthOptions } from '@storebrand-digital/auth';
import { createAuthClient } from '@bank/auth';
import { getEnv } from '@/utils/env';

const options: AuthOptions = {
  config: {
    realm: window.env.KEYCLOAK_REALM,
    clientId: window.env.KEYCLOAK_CLIENT,
    url: window.env.KEYCLOAK_URL,
  },
  init: {
    scope: window.env.KEYCLOAK_SCOPE,
  },
  login: {
    scope: window.env.KEYCLOAK_SCOPE,
    allowedACR: [
      'https://id.storebrand.no/authn/al3',
      'https://id.storebrand.no/authn/al4',
    ],
  },
  logout: {
    redirectUri: window.env.KEYCLOAK_LOGOUT_REDIRECT,
  },
};

export const auth = createAuthClient(options, getEnv());

export default auth;
